<template>
  <ClaimDetails v-bind:admin-view="false" />
</template>

<script>
import ClaimDetails from "@/components/claim/details/ClaimDetails.vue";

export default {
  components: {
    ClaimDetails,
  },
};
</script>
